// icon:pencil | Entypo http://entypo.com/ | Daniel Bruce
import * as React from "react";

function IconPencil(props) {
  return (
    <svg
      className="icon-edit-character"
      viewBox="0 0 780 1000"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M718 170c21.333 21.333 37 42.667 47 64s15 37.333 15 48v16L528 550 238 838 0 890l50-240 290-288 252-252c36-8 78 12 126 60M224 810l24-24c-1.333-29.333-18.667-60.667-52-94-14.667-14.667-29.667-26.333-45-35-15.333-8.667-27-13-35-13l-14-2-22 24-18 80c18.667 10.667 34 22 46 34 16 16 28 32 36 48l80-18" />
    </svg>
  );
}

export default IconPencil;
